/**
 * 接口地址配置
 *
 * 优先级：
 *   1. 运行时配置 window.__APP_CONFIG__.baseURL（部署包根目录 config.js，改完刷新即生效）
 *   2. 构建时默认值（生产 → 测试环境地址；开发 → /system 走 devServer 代理）
 */
const runtimeConfig = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}

const BUILD_DEFAULT_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'http://test.cikonbms.com/system'
  : '/system'

export const BASE_URL = (runtimeConfig.baseURL || '').trim() || BUILD_DEFAULT_BASE_URL
